<template>
  <div @click="clickConfirm" id="bumpmap-marker-confirm-button" class="bumpmap-marker-confirm">
    <q-btn
      class="confirm-button q-gt-sm"
      round
      push
      color="green"
      text-color="white"
      icon="check"
      size="md"
    />
  </div>
</template>

<script>
import * as Rx from 'rx-dom'
import { dispatch } from '@/state'

export default {
  name: 'AddPinMarkerConfirmButton',
  methods: {
    clickConfirm(event) {
      dispatch.pins.confirmNewPin()
    },
    onMouseOver(event) {
      console.warn('onMouseOver', event)
    },
  },
  data() {
    return {
      clickSub: null,
    }
  },
}
</script>

<style lang="scss">
.bumpmap-marker-confirm {
  .confirm-button {
    pointer-events: auto;
  }
}
</style>
